import { createContext } from 'react';

export const SearchContext = createContext({
    toggleSearch: () => {},
    searchTerm: '',
    setSearchTerm: () => {},
    clearSearch: () => {},
    searchPlaceholder: 'Cerca...',
});
